// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aside":"aside-20Ngiuxp","ad":"ad-3rr-UkDX"};